export default class UserData {
    Uid = 0;
    Username = "";
    Score = 0;
    Coin = 0;
    Sex = 0; // 1-boy, 0-girl  
    InviteCode = '';
    Pic = '';
    Vip = 0;
    Exp = 0;
    Sign = '';
    LikeNum = 0;
    isSign = true;
    PhoneNum = '';
    token = '';
    PcToken = '';
    RealStatus = 0;
    customer_id = 0;
    userSign = '';
    identifier = '';

    isLogin() {
        return this.token != '';
    }

    getUid() {
        let user_id = this.Uid;
        if (this.Uid == 0) {
            let s = this.identifier.split('_');
            if (s && s.length == 2) {
                user_id = s[1];
            }
        }
        return user_id;
    }
}
